"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../Icon/index");
var _VisuallyHidden = require("../VisuallyHidden/VisuallyHidden");
var _CloseButton = require("./CloseButton.styles");
var _excluded = ["children", "label"];
var CloseButton = function CloseButton(_ref) {
  var children = _ref.children,
    label = _ref.label,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_CloseButton.StyledCloseButton, rest, children || /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.VisuallyHidden, null, label), /*#__PURE__*/_react.default.createElement(_index.IconClose, {
    size: "xs"
  })));
};
exports.CloseButton = CloseButton;
CloseButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * @deprecated We are deprecating the use of aria-label given the inconsistent and buggy
   * experience that it gives screen readers, specifially Windows and NVDA.
   */
  'aria-label': _propTypes.default.string,
  /**
   * Used to tell screenreaders what to speak for this button.
   * This will leverage the VisuallyHidden component to allow a
   * consistent experience and solve a NVDA bug.
   */
  'label': _propTypes.default.string,
  /**
   * The close button content, by default a close icon.
   */
  'children': _propTypes.default.node
} : {};
CloseButton.defaultProps = {
  label: 'Close'
};